function stripHtmlTags(text: string): string {
  // Remove HTML tags
  let cleaned = text.replace(/<[^>]*>/g, '');
  // Decode common HTML entities
  cleaned = cleaned
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ');
  return cleaned.trim();
}

export function getErrorMessage(error: unknown): string | null {
  let message: string | null = null;

  if (error instanceof Error && error.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  } else if (error && typeof error === 'object' && 'message' in error) {
    const msg = (error as { message?: unknown }).message;
    if (typeof msg === 'string' && msg.trim()) {
      message = msg;
    }
  }

  if (!message) {
    return null;
  }

  // If the message contains HTML, strip it out or replace with a friendly message
  if (message.includes('<!DOCTYPE') || message.includes('<html') || message.includes('<body')) {
    return 'Unable to connect to server. Please check that the server is running.';
  }

  // Strip any remaining HTML tags
  if (message.includes('<') && message.includes('>')) {
    message = stripHtmlTags(message);
  }

  return message;
}

export function toErrorWithMessage(error: unknown, fallback: string): string {
  const message = getErrorMessage(error);
  return message ?? fallback;
}
